// Shim re-export to preserve existing import path
// The metrics command has been folderized under ./metrics/
export { metricsCommand } from "./metrics/index.js";
